import merge from 'classnames';

import styles from './DefaultTag.module.scss';

export type DefaultTagProps = {
  isSelected: boolean;
};

export const DefaultTag = ({ isSelected }: DefaultTagProps) => (
  <div
    className={merge(styles.default_tag, {
      [styles.default_tag_active]: isSelected,
    })}
    data-testid="gafe-default-tag"
  >
    Default
  </div>
);
